module.exports = __webpack_public_path__ + "static/media/copy_paste.a60ed0e7.svg";